import { useState } from "react"
import { router } from "@inertiajs/react"

import SearchField from "./SearchField"

// The topbar's search box. It was a bare field with no submit — Enter did
// nothing (UPDA-98). It now searches the customer's projects: Enter visits
// /projects with the term, and the Projects page seeds its own filter from
// that query so the list opens already narrowed (by project title or order
// number, the filter's own rule). A whitespace-only term is not a search. The
// placeholder is distinct from the Projects list's own "Search projects…" so
// the two fields never read as one.
export function searchTerm(value) {
  return typeof value === "string" ? value.trim() : ""
}

export default function TopbarSearch({ className }) {
  const [value, setValue] = useState("")

  const submit = (event) => {
    event.preventDefault()
    const q = searchTerm(value)
    if (!q) return
    router.get("/projects", { q })
  }

  return (
    <form role="search" onSubmit={submit} className={className}>
      <SearchField
        value={value}
        onChange={setValue}
        placeholder="Find a project…"
        aria-label="Search projects"
        name="q"
      />
    </form>
  )
}
